import { RUNNING_ASSESSMENT_STATUSES, } from "@piiqtechnologies/ui-lib";
import { getReportStatusKey } from "@utils/reportStatus";
const frequencyLabel = (days) => {
    if (days === 1)
        return "Daily";
    if (days === 7)
        return "Weekly";
    if (days === 14)
        return "Bi-weekly";
    if (days === 30)
        return "Monthly";
    if (days === 90)
        return "Quarterly";
    return `Every ${days} days`;
};
const calculateGrowthPercentage = (current, baseline) => {
    if (baseline === 0)
        return 0;
    return Number((((current - baseline) / baseline) * 100).toFixed(1));
};
const formatDate = (dateStr) => {
    if (!dateStr)
        return null;
    const date = new Date(dateStr);
    if (isNaN(date.getTime()))
        return null;
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(-2);
    return `${mm}/${dd}/${yy}`;
};
export const buildCommunityTemplateRows = ({ templates, reports, subjectId, subjectName, fallbackLatestReportDate, }) => {
    var _a, _b, _c;
    const sortedReports = [...(reports !== null && reports !== void 0 ? reports : [])].sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());
    const latestReportDate = (_c = (_b = (_a = sortedReports[0]) === null || _a === void 0 ? void 0 : _a.createdOn) !== null && _b !== void 0 ? _b : fallbackLatestReportDate) !== null && _c !== void 0 ? _c : null;
    return templates.map((t) => {
        var _a, _b, _c, _d;
        const hasBeenRun = !!t.lastAssessmentAt;
        const templateReports = sortedReports.filter((r) => r.templateId === t._id);
        const currentReport = (_a = templateReports.find((r) => !r.createdOn)) !== null && _a !== void 0 ? _a : templateReports[0];
        const isRunning = !!(currentReport === null || currentReport === void 0 ? void 0 : currentReport.status) && RUNNING_ASSESSMENT_STATUSES.includes(currentReport.status);
        let templateChange;
        if (templateReports.length >= 2) {
            const current = Number(templateReports[0].latestScore);
            const previous = Number(templateReports[1].latestScore);
            if (!isNaN(current) && !isNaN(previous)) {
                templateChange = calculateGrowthPercentage(current, previous);
            }
        }
        const templateLatestScore = hasBeenRun && templateReports.length > 0
            ? templateReports[0].latestScore !== undefined && templateReports[0].latestScore !== null
                ? Math.round(Number(templateReports[0].latestScore))
                : "-"
            : "-";
        return {
            templateId: t._id,
            isActive: t.isActive,
            tierLabel: ((_b = t.llmProviders) === null || _b === void 0 ? void 0 : _b.length) > 1 ? "Premium" : "Basic",
            templateName: t.name,
            reports: hasBeenRun ? ((_c = templateReports.length) !== null && _c !== void 0 ? _c : 0) : 0,
            frequency: frequencyLabel(t.frequencyDays),
            latestRun: hasBeenRun ? formatDate((_d = t.lastAssessmentAt) !== null && _d !== void 0 ? _d : latestReportDate) : null,
            latestScore: templateLatestScore,
            latestChange: hasBeenRun ? templateChange : undefined,
            nextRunOn: formatDate(t.nextReportAt),
            aiModels: t.llmProviders,
            subjectId,
            subjectName,
            status: isRunning ? "running" : undefined,
            reportStatus: getReportStatusKey(currentReport === null || currentReport === void 0 ? void 0 : currentReport.status),
            currentReportId: currentReport === null || currentReport === void 0 ? void 0 : currentReport.reportId,
            variableCollectionId: t.assessmentVariableCollectionId,
        };
    });
};
